import { MessageDescriptor } from '@redbubble/next/intl';

// XXX: Default number of product tiles requested per L2 carousel.
export const DEFAULT_L2_RESULT_COUNT = 10;

export const L1_CATEGORY_SLUGS = [
  'music',
  'television',
  'movies',
  'animals',
  'gaming',
  'sports',
  'funny',
  'books',
  'anime', // TODO: remove before release. Good one to test mature content for now
] as const;

export type L1CategorySlug = (typeof L1_CATEGORY_SLUGS)[number];

export const isL1CategorySlug = (slug: string): slug is L1CategorySlug =>
  (L1_CATEGORY_SLUGS as readonly string[]).includes(slug);

export type L2CategoryConfig = {
  slug: string;
  title: MessageDescriptor;
  query: string;
  seeAllPath: string;
  resultCount: number;
  active?: boolean;
  iconName?: string;
};

export type L1CategoryConfig = {
  slug: string;
  title: MessageDescriptor;
  attributiveTitle: MessageDescriptor;
  l2Categories: L2CategoryConfig[];
};

export type CategoryConfig = Record<L1CategorySlug, L1CategoryConfig>;
